import React, { useEffect, useMemo, useRef, useState } from "react";
import "./scss/Storefront.scss";
import { Container, Col, Row, Card, Button, Spinner } from "react-bootstrap";
import formatCurrency from "../../utils/currencyFormmter";
import { useDispatch, useSelector } from "react-redux";
import { addToCart, clearCart, removeFromCart, initializeCartSession} from "../../redux/slices/cartSlice.slice";
import Swal from "sweetalert2";
import FloatingCart from "../../components/FloatingCart";
import Cart from "../../components/Cart";
import axios from "axios";
import { useParams } from "react-router-dom";
import { sidebarToggle } from "../../redux/slices/auth";
import MarketplaceHeader from "../../components/MarketplaceHeader";
import MarketPlaceContact from "../../components/MarketPlaceContact";
import wallxLogo from "../../assets/images/logo_white.svg"
import Footer from "../../components/Footer";
import { usePaystackPayment } from "react-paystack";
import shortenText from "../../utils/shortenText";
import { getOrgVAT } from "../../redux/slices/inventory.slice";
import LoadingOverlay from "../../components/LoadingOverlay";

const MarketPlace = () => {

  const isLoaded = useRef(false);
  const dispatch = useDispatch();
  const { items: cart } = useSelector((state) => state.cart);
  const { reference } = useParams("reference")
  // const { merchant = {}}  = useSelector((state) => state.inventory)

  const BASE_URL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_INVETORY_API_PROD : process.env.REACT_APP_INVETORY_API

  useEffect(() => {
    dispatch(initializeCartSession());
  }, [dispatch]);

  const initialState = {
    products: [],
    loading: false,
    payload: {
      sortBy: "desc",
      payment_method: "DEBIT CARD",
      full_name: "",
      email: "",
      notes: "",
    },
    sending: false,
    printReceipt: false,
    orderNumber: "",
    showLink: false,
    link: "",
    paystackKey: "",
    errors: {},
    vat: 0,
    consumption_tax: 0,
    grandTotal: 0,
    merchant: {},
    method: 'card',
    fees: [],
    fee: 0,
    tax: {vat: 0, consumption_tax: 0, delivery_fee: 0, delivery_note: ''},
    showPaymentOptions: false,
    sendingRequest: false,
  }

  const [state, setState] = useState(initialState)
  const totalPrice = cart.reduce((sum, item) => sum + (item.sales_price * item.quantity), 0)
  const vatAmount = totalPrice * (state?.tax?.vat/100);
  const consumptionTaxAmount = totalPrice * (state?.tax?.consumption_tax/100);
  const expand = cart.length == 0
  const grandTotalAmount = totalPrice + vatAmount + consumptionTaxAmount + state.fee + parseFloat(state?.tax?.delivery_fee || 0)

  const paymentConfig = {
    refernce: (new Date()).getTime().toString(),
    email: state.payload.email,
    amount: Math.round(grandTotalAmount * 100),
    metadata: {
      custom_fields: [
        {
          merchant_id: state.merchant?.reference,
          amount: state.grandTotal,
          currency: "NGN",
          customer_name: state.payload.full_name,
        }
      ]
    },
    publicKey: state.paystackKey,
    channels: ['card']
  }

  const initializePayment = usePaystackPayment(paymentConfig)

  useEffect(() => {
    if (!isLoaded.current) {
      loadProducts();
      getThirdPartyKeys()
      if(reference) {
        getVat(reference)
      }
      isLoaded.current = true;
    }
  }, []);

  const memoizedConfig = useMemo(() => ({
    fee: state.fee,
    fees: state.fees,
    payload: state.payload,
    grandTotal: state.grandTotal,
    paystackKey: state.paystackKey,
    tax: state.tax,
    showPaymentOptions: state.showPaymentOptions,
    merchantId: reference,
    isMarketPlace: true,
    loading: state.sending,
  }), [state.fee, state.payload, state.grandTotal, state.fees, state.paystackKey, state.tax, state.showPaymentOptions, state.sending]);

  const handlePayment = () => {
    if(state?.payload.full_name === "" || state?.payload.email === "") {
      Swal.fire({
        icon: 'error',
        title: 'Incomplete Information',
        text: 'Please provide both Customer Name and Customer Email to proceed with the payment. Thank you!',
      })
      return;
    }
    setState((prev) => ({...prev, showPaymentOptions: !state.showPaymentOptions}))
  }


  const loadProducts = () => {
    setState((prevState) => ({...prevState, loading: true}))
    axios.get(`${BASE_URL}/admin/marketplace/product-listing/${reference}?sortBy=${state.payload.sortBy}`)
    .then((response) => {
      if(response.data.status && response.data.status === true) {
        const products = response.data?.data?.data
        const merchant = response.data?.merchant
        setState((prevState) => ({...prevState, products: products, merchant: merchant }))
      }
    })
    .catch((error) => {
      const message = error?.response?.data?.message || error?.message
      Swal.fire({
        icon: "error",
        title: "Error",
        text: message || 'An error occured'
      })
    })
    .finally(() => setState((prevState) => ({...prevState, loading: false})))
  }

  const onPaymentSuccess = (data) =>  {
    // Swal.fire({
    //   icon: 'success',
    //   text: 'Your order has been submitted successfully'
    // })
    // // verifyPaystackPayment(data.reference)
    // // finalizeOrder("settled")
    // .then(() => setState((prevState) => ({...prevState, printReceipt: true })))
    placeOrder('settled');
  }

  const onPaymentDialogClose = () =>  {
  }

  const checkout = () => {
    // console.log("checkout called", paymentConfig)

    if(state.payload.full_name === '' || state.payload.email === '') {
      Swal.fire({
        title: "Error",
        icon: "error",
        text: "Customer name and email address are required"
      })
      return;
    }

    Swal.fire({
      icon: "warning",
      text: "Are you sure to place this order?",
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: "Yes, Proceed"
    })
    .then((result) => {
      if(result.isConfirmed) {
        processPayment()
      }
    })
  }

  const placeOrder  = (paymentStatus) => {
    let requestPayload = {
      items: cart,
      orderTotal: totalPrice,
      payment_method: state.payload.payment_method,
      reference: state.merchant?.id,
      notes:  state.payload.notes || "",
      fee: state.fee || 0,
      customer_details: {
        full_name: state.payload.full_name,
        email: state.payload.email,
        phone_number: state.payload.phone_number || "",
      },
    }

    setState((prevState) => ({...prevState, sendingRequest: true}))
    axios.post(`${BASE_URL}/admin/marketplace/order/submit`, requestPayload)
    .then((response) => {
      if(response.data?.status === true) {
        const orderNumber = response.data?.data?.order_number
        setState((prevState) => ({...prevState, orderNumber: orderNumber, showPaymentOptions: false, printReceipt: true}))
        // initializePayment(onPaymentSuccess, onPaymentDialogClose)
        // processPayment(response.data?.data)
        Swal.fire({
          icon: 'success',
          text: `Your order is process. Your order number is #${orderNumber}`,
          
        })
        .then(() => {
          // handleClear()
          finalizeOrder(paymentStatus, orderNumber)
        })
      }
      else {
        Swal.fire({
          icon: 'error',
          text: response.data?.message
        })
      }
    })
    .catch((error) => {
      const message = error?.response?.data?.message || error?.message
      // console.log("Error", error)
      Swal.fire({
        icon: "error",
        title: "Error",
        text: message || 'An error occured'
      })
    })
    .finally(() => setState((prevState) => ({...prevState, sendingRequest: false})))
  }

  const handleAddToCart = (product) => {
    dispatch(addToCart(product));
  };

  const handleRemoveFromCart = (id) => {
    dispatch(removeFromCart(id));
  };

  const handleClear = () => {
    dispatch(clearCart());
    setState((prevState) => ({...prevState, printReceipt: false}))
  };

  const isProductInCart = (id) => {
    return cart.some((item) => item.id === id);
  };

  const serverSideSearch = (event) => {
    const value = event.target.value;
    let requestPayload = state.payload
    state.payload.filter = value

    if (value.length >= 3) {
      setState((prevState) => ({...prevState, loading: true}))
      axios.get(`${BASE_URL}/admin/marketplace/product-listing/${reference}?q=${state.payload.filter}&sortBy=${state.payload.sortBy}`)
      .then((response) => {
        if(response.data?.status && response.data?.status === true) {
            setState((prevState) => ({...prevState, products: response.data.data.data}))
        }
        else {
          setState((prevState) => ({...prevState, products: []}))
        }
      })
      .catch((error) => {
        const message = error?.response?.data?.message || error?.message
        Swal.fire({
          icon: "error",
          title: "Error",
          text: message || 'An error occured'
        })
      })
      .finally(() => setState((prevState) => ({...prevState, loading: false})))
    }
    else if (value.length === 0) {
      loadProducts()
    }
  }

  const sortProducts = (order) => {
    setState((prevState) => ({...prevState, payload: {...prevState.payload, sortBy: order}}))
    loadProducts()
  }

  const handleInput = (event) => {
    const {name, value} = event.target
    setState((prevState) => ({...prevState, payload: {...prevState.payload, [name]: value}}))
    if(name === 'payment_method' && value === 'card') {
      getFees(totalPrice)
    } else {
      setState((prev) => ({...prev, grandTotal: totalPrice.toFixed(2), fee: 0}))
    }
  }

  const menuToggle = () => {
    dispatch(sidebarToggle())
  }

  const processPayment = (orderData) => {
    if(state.payload.payment_method === 'card') {
      initializePayment(onPaymentSuccess, onPaymentDialogClose)
    } else if(state.payload.payment_method === 'paycode') {
      payWithPaycode()
    }
  }

  const finalizeOrder = (status, orderNumber) => {
    axios.post(`${BASE_URL}/admin/marketplace/payment-verification`, {
        reference: orderNumber, 
        status: status
    })
    .then((response) => {
        console.log("finalize", response)
        if(response.data?.status === true) {
            // Swal.fire({
            //     icon: 'success',
            //     text: response.data?.message
            // })
        }
        else {
            // Swal.fire({
            //     icon: 'error',
            //     text: response.data?.message
            // })
        }
    })
    .catch((error) => {
      const message = error?.response?.data?.message || error?.message
      Swal.fire({
        icon: "error",
        title: "Error",
        text: message || 'An error occured'
      })
    })
  }

  const verifyPaystackPayment = (reference) => {
    axios.post(`${process.env.NODE_ENV === 'production' ? process.env.REACT_APP_BASE_URL_PROD : process.env.REACT_APP_BASE_URL_DEV}/api-v1/qr_pay_paystack/${state.merchant?.reference}`, {
        reference: reference,
        customer_name: state.payload.full_name,
    })
    .then((response) => {
        if(response.data?.success === true) {
            Swal.fire({
                icon: 'success',
                text: response.data?.message
            })
        }
        else {
            Swal.fire({
                icon: 'error',
                text: response.data?.message
            })
        }
    })
    .catch((error) => {
        Swal.fire({
            icon: 'error',
            text: error.response?.data?.message
        })
    })
  }

  const getThirdPartyKeys = () => {
    const credentials = `${process.env.REACT_APP_CLIENT_USER}:${process.env.REACT_APP_CLIENT_KEY}`
    const base64Credentials = btoa(credentials)
    axios.get(`${process.env.NODE_ENV === 'production' ? process.env.REACT_APP_BASE_URL_PROD : process.env.REACT_APP_BASE_URL_DEV}/api-v1/third_party_keys/`, {
        headers: {
            Authorization: `Basic ${base64Credentials}`
        }
    })
    .then(response => {
      if(response.data.data !== 'undefined') {
        const data = response.data.data
        if(data.pay_stack_live_key) {
          setState((prevState) => ({...prevState,  paystackKey:data.pay_stack_public_key }))
        }
      }
    }) 
    .catch(err => {
        // console.log(err)
    })
  }

  const setVatRate = (tax) => {
    if(state.vat === 0) {
      const grandTotal = parseFloat(totalPrice) + parseFloat(tax.vat) + parseFloat(tax.consumption_tax)
      setState((prevState) => ({...prevState, tax: tax, vat: tax.vat, consumption_tax: tax.consumption_tax, grandTotal: grandTotal.toFixed(2)}))
    }
  }

  const getFees = async (grandTotal) => {

    // If we already have fees, use them directly
    if (state.fees && state.fees.length > 0) {
      return calculateFees(state.fees, grandTotal);
    }
  
    try {
      // Fetch only if not fetched previously
      const baseUrl =
        process.env.NODE_ENV === "production"
          ? process.env.REACT_APP_BASE_URL_PROD
          : process.env.REACT_APP_BASE_URL_DEV;
  
      const res = await axios.get(`${baseUrl}/transaction_charges/`);
  
      if (res.data?.length) {
        const paymentFees = res.data;
        // console.log("Fetched payment fees:", paymentFees);
  
        // Save fees to state for future calls
        setState((prev) => ({ ...prev, fees: paymentFees }));
  
        // Now calculate using fetched fees
        calculateFees(paymentFees, grandTotal);
      } else {
        console.log("No payment fees returned from server.");
      }
    } catch (err) {
      console.error("Failed to fetch payment fees:", err);
    }
  }
  
  const calculateFees = (paymentFees, grandTotal) => {
    const paystackFee = paymentFees.find((fee) => fee.name === "paystack");
    if (!paystackFee) return;
  
    let percentage = (paystackFee.value / 100) * grandTotal;
  
    // cap fee at 3000
    percentage = percentage > 3000 ? 3000 : parseFloat(percentage);
  
    let totalAmount = grandTotal;
    if (state.method === "card") {
      totalAmount += percentage;
    }
  
    // console.log("Total Amount:", totalAmount);
    // console.log("Fee:", percentage);
  
    setState((prev) => ({
      ...prev,
      grandTotal: totalAmount.toFixed(2),
      fee: percentage,
    }));
  }

  const getVat = (merchantId) => {
    dispatch(getOrgVAT(merchantId))
    .then((response) => {
        if(response.payload?.status) {
          // setState(prevState => ({...prevState, vat: response.payload.data?.vat, tax: response.payload.data}))
          setVatRate(response.payload.data)
        }
    })
  }

  const payWithPaycode = () => {
    if (!state.payload.token && !state.payload.secret) return;
    setState((prev) => ({...prev, sendingRequest: true}))

    let request_payload = state.payload
    request_payload.amount = totalPrice + vatAmount + consumptionTaxAmount + state.fee + state.tax.delivery_note
    request_payload.pay_mode = 'paycode'
    request_payload.order_number = '' //invoice?.ref

    axios.post(`${process.env.NODE_ENV === 'production' ? process.env.REACT_APP_BASE_URL_PROD : process.env.REACT_APP_BASE_URL_DEV}/api-v1/pay_invoice/${'invoice.id'}`, request_payload)
    .then((res) => {
        if(res.payload?.success === true) {
            Swal.fire({
                icon: 'success',
                text: res.payload?.message
            })
            .then(() => {
                // setState((prevState)=> ({...prevState, 'show_rating_form': true}))
                placeOrder('settled')
            })
        }
        else {
            Swal.fire({
                icon: 'error',
                text: res.payload?.message
            })
        }
    })
    .finally(() => setState((prev) => ({...prev, sendingRequest: false})))
  }

  // if(!state.sending) {
  //   return (
  //     <LoadingOverlay
  //       message="Processing"
  //       showProgress={true}
  //     />
  //   );
  // }

  return (
    <div style={{ 
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh'
    }}>
      {
        state.sendingRequest && <LoadingOverlay message="Processing...." />
      }
      <MarketplaceHeader
        menuToggle={menuToggle}
        serverSideSearch={serverSideSearch}
        sortProducts={sortProducts}
        sortBy={state.payload.sortBy}
        sidebarHidden={false}
        storeName={ state.merchant?.name || "" }
        brandLogo={ state.merchant?.logo || wallxLogo }
      />
      <main>
        <Container className="mt-4 mb-5">
            <MarketPlaceContact 
              phoneNumber={state.merchant?.whatsapp_phone_number || state.merchant?.phone_number || ""} 
              emailAddress={state.merchant?.email || ""}
            />
            <Row>
                <Col md={expand ? 12 : 8} className="product-grid no-print">
                  <div className="text-center mt-3 text-primary">
                      { state.loading && <Spinner size="sm" /> } 
                  </div>
                  <Row xs={1} sm={2} md={expand ? 3 : 2} lg={expand ? 4 : 3} className="g-4">
                      {state.products.map((product) => (
                      <Col key={product.id}>
                          <Card 
                          className={`h-100 border-0 single-product`} 
                          onClick={() => !isProductInCart(product.id) ? handleAddToCart(product) : null}
                          style={{ overflow: 'hidden' }}
                          >
                          <div 
                              className="d-flex justify-content-center align-items-center" 
                              style={{
                              height: '200px', 
                              overflow: 'hidden',
                              backgroundColor: '#ffffff'
                              }}
                          >
                              <Card.Img 
                                variant="top" 
                                src={product.image} 
                                style={{
                                    objectFit: 'contain', 
                                    width: 'auto',
                                    maxHeight: '100%',
                                    maxWidth: '100%'
                                }}
                                className="mx-auto" 
                                onError={(e) => {
                                    e.target.src = 'https://placehold.co/400x400'; 
                                }}
                              />
                          </div>
                          
                          <Card.Body className="d-flex flex-column">
                              <Card.Title className="text-center mb-2">{product.name}</Card.Title>
                              <Card.Text className="text-center text-primary fw-bold">
                                {formatCurrency(product.sales_price).with_currency}
                              </Card.Text>
                              <Card.Text className="text-center text-muted" style={{ fontSize: '14px', flexGrow: 1 }}>
                                {product.description ? shortenText(product.description, 150) : "No description available."}
                              </Card.Text>
                          </Card.Body>
                          
                          <Card.Footer className="bg-white border-0 pt-0">
                              <Button 
                                variant={isProductInCart(product.id) ? "success" : "primary"}
                                className="w-100"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    isProductInCart(product.id) 
                                    ? handleRemoveFromCart(product.id) 
                                    : handleAddToCart(product);
                                }}
                              >
                              {isProductInCart(product.id) ? "Added to Cart" : "Add to Cart"}
                              </Button>
                          </Card.Footer>
                          </Card>
                      </Col>
                      ))}
                  </Row>
                    {
                    state.products.length === 0 && <Col md={12} className="text-center mt-5">No items available</Col>
                    }
                </Col>

                <Col md={4} sm={12} className={`cart mt-5 storefront-cart ${expand ? 'd-none' : ''}`}>
                  <Cart 
                      cartItems={cart}
                      handleSubmit={checkout}
                      requestStatus={state.sending}
                      printReceipt={state.printReceipt}
                      clearCart={handleClear}
                      handleInput={handleInput}
                      orderNumber={state.orderNumber}
                      // isMarketPlace={true}
                      payWithPaycode={payWithPaycode}
                      // merchantId={reference}
                      handlePaymentOption={handlePayment}
                      paymentConfig={memoizedConfig}
                  />
                  <FloatingCart>
                      <Cart 
                        cartItems={cart}
                        handleSubmit={checkout}
                        requestStatus={state.sending}
                        printReceipt={state.printReceipt}
                        clearCart={handleClear}
                        handleInput={handleInput}
                        orderNumber={state.orderNumber}
                        // isMarketPlace={true}
                        payWithPaycode={payWithPaycode}
                        // merchantId={reference}
                        handlePaymentOption={handlePayment}
                        paymentConfig={memoizedConfig}
                      />
                  </FloatingCart>
                </Col>
            </Row>
        </Container>
      </main>
      <Footer/>
    </div>
  );
};

export default MarketPlace;